/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_CAPTURE_GUIDE, CAPTURE_GUIDE_RECEIVED } = constants.GetCaptureGuideConstants;

export default {
  REQUEST_CAPTURE_GUIDE,
  CAPTURE_GUIDE_RECEIVED,

  requestCaptureguide: payload => ({
    type: REQUEST_CAPTURE_GUIDE,
    payload
  }),
  CaptureguideReceived: () => ({
    type: CAPTURE_GUIDE_RECEIVED
  })
};
